import { useEffect, useState } from "react";
import { Avatar, Container, Paper, Link, Alert, Box, Typography } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import SignUp from "./SignUp";
import SignIn from "./SignIn";
import ILog from "../../types/Log";
import LogService from "../../services/LogService";
import { createTheme } from '@mui/material/styles';
import ChangePass from "./ChangePass";
import { getVersion } from "../../services/VersionService";
import { APP_VERSION } from "../../version";
import { useLocation } from "react-router-dom";

const Auth = () => {
    const theme = createTheme();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const userId = params.get("userId");
    const register = params.has("register");

    const [isSignup, setIsSignUp] = useState(register || userId !== null);
    const [isChangePass, setIsChangePass] = useState(false);
    const [apiVersion, setApiVersion] = useState<string>("");

    useEffect(() => {
        const fetchVersion = async () => {
            try {
                const res = await getVersion();
                setApiVersion(res.data.apiVersion);
            } catch {
                setApiVersion("unknown");
            }
        };  

        fetchVersion();
    }, []);

    const switchMode = () => {
        setIsSignUp(!isSignup);
    };

    useEffect(() => {
        if (userId) {
            setIsSignUp(true);
        }
    }, [userId]); 

    try {
        return (
            <Container maxWidth={isSignup ? "md" : "sm"}>
                <Paper elevation={3} sx={{ marginTop: theme.spacing(3), marginBottom: theme.spacing(3), padding: theme.spacing(3), display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Avatar sx={{ margin: theme.spacing(1), backgroundColor: theme.palette.secondary.main }}>
                        <LockIcon />
                    </Avatar>

                    { isChangePass ? <ChangePass /> : isSignup ? <SignUp userId={userId} /> : <SignIn />}

                    <Box display="flex" justifyContent="space-between" width={"100%"} mt={2} mb={2}>
                        <Link sx={{ cursor: 'pointer' }} variant="body2" onClick={() => { setIsChangePass(!isChangePass) }}>{isChangePass ? 'Volver' : '¿Se te olvidó la contraseña?'}</Link>
                        {!isChangePass && <Link sx={{ cursor: 'pointer' }} onClick={switchMode} variant="body2">{isSignup ? '¿Ya tienes una cuenta? Inicia sesión' : '¿No tienes una cuenta? Regístrate'}</Link>}
                    </Box>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            mt: 1,
                            opacity: 0.45
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: "10px",
                                letterSpacing: 0.5,
                                color: "text.disabled",
                                userSelect: "none"
                            }}
                        >
                            v{APP_VERSION} · {apiVersion}
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        );
    } catch (e: any) {
        const error: ILog = { method: 'Auth.Component', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return (
            <Alert severity="error">{e.message}</Alert>
        );
    }
};

export default Auth;